/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Tabs_NotificationsInputs */

const id_notifications_tabs_notifications = /** @type {(inputs: Notifications_Tabs_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifikasi`)
};

const ms_notifications_tabs_notifications = /** @type {(inputs: Notifications_Tabs_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemberitahuan`)
};

const da_notifications_tabs_notifications = /** @type {(inputs: Notifications_Tabs_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifikationer`)
};

const de_notifications_tabs_notifications = /** @type {(inputs: Notifications_Tabs_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungen`)
};

const en_us2_notifications_tabs_notifications = /** @type {(inputs: Notifications_Tabs_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications`)
};

const es_es2_notifications_tabs_notifications = /** @type {(inputs: Notifications_Tabs_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificaciones`)
};

const es_mx2_notifications_tabs_notifications = /** @type {(inputs: Notifications_Tabs_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificaciones`)
};

const fil_notifications_tabs_notifications = /** @type {(inputs: Notifications_Tabs_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Notipikasyon`)
};

const fr_notifications_tabs_notifications = /** @type {(inputs: Notifications_Tabs_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications`)
};

const it_notifications_tabs_notifications = /** @type {(inputs: Notifications_Tabs_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifiche`)
};

const hu_notifications_tabs_notifications = /** @type {(inputs: Notifications_Tabs_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Értesítések`)
};

const nl_notifications_tabs_notifications = /** @type {(inputs: Notifications_Tabs_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meldingen`)
};

const no_notifications_tabs_notifications = /** @type {(inputs: Notifications_Tabs_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varsler`)
};

const pl_notifications_tabs_notifications = /** @type {(inputs: Notifications_Tabs_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powiadomienia`)
};

const pt_br2_notifications_tabs_notifications = /** @type {(inputs: Notifications_Tabs_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificações`)
};

const pt_notifications_tabs_notifications = /** @type {(inputs: Notifications_Tabs_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificações`)
};

const ro_notifications_tabs_notifications = /** @type {(inputs: Notifications_Tabs_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificări`)
};

const fi_notifications_tabs_notifications = /** @type {(inputs: Notifications_Tabs_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmoitukset`)
};

const sv_notifications_tabs_notifications = /** @type {(inputs: Notifications_Tabs_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notiser`)
};

const vi_notifications_tabs_notifications = /** @type {(inputs: Notifications_Tabs_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông báo`)
};

const tr_notifications_tabs_notifications = /** @type {(inputs: Notifications_Tabs_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildirimler`)
};

const cs_notifications_tabs_notifications = /** @type {(inputs: Notifications_Tabs_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oznámení`)
};

const bg_notifications_tabs_notifications = /** @type {(inputs: Notifications_Tabs_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Известия`)
};

const ru_notifications_tabs_notifications = /** @type {(inputs: Notifications_Tabs_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уведомления`)
};

const uk_notifications_tabs_notifications = /** @type {(inputs: Notifications_Tabs_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сповіщення`)
};

const ar_notifications_tabs_notifications = /** @type {(inputs: Notifications_Tabs_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإشعارات`)
};

const hi_notifications_tabs_notifications = /** @type {(inputs: Notifications_Tabs_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सूचनाएँ`)
};

const th_notifications_tabs_notifications = /** @type {(inputs: Notifications_Tabs_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การแจ้งเตือน`)
};

const ja_notifications_tabs_notifications = /** @type {(inputs: Notifications_Tabs_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知`)
};

const zh_cn2_notifications_tabs_notifications = /** @type {(inputs: Notifications_Tabs_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知`)
};

const zh_hant1_notifications_tabs_notifications = /** @type {(inputs: Notifications_Tabs_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知`)
};

const ko_notifications_tabs_notifications = /** @type {(inputs: Notifications_Tabs_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`알림`)
};

/**
* | output |
* | --- |
* | "Notifications" |
*
* @param {Notifications_Tabs_NotificationsInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_tabs_notifications = /** @type {((inputs?: Notifications_Tabs_NotificationsInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Tabs_NotificationsInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_tabs_notifications(inputs)
	if (locale === "ms") return ms_notifications_tabs_notifications(inputs)
	if (locale === "da") return da_notifications_tabs_notifications(inputs)
	if (locale === "de") return de_notifications_tabs_notifications(inputs)
	if (locale === "en-US") return en_us2_notifications_tabs_notifications(inputs)
	if (locale === "es-ES") return es_es2_notifications_tabs_notifications(inputs)
	if (locale === "es-MX") return es_mx2_notifications_tabs_notifications(inputs)
	if (locale === "fil") return fil_notifications_tabs_notifications(inputs)
	if (locale === "fr") return fr_notifications_tabs_notifications(inputs)
	if (locale === "it") return it_notifications_tabs_notifications(inputs)
	if (locale === "hu") return hu_notifications_tabs_notifications(inputs)
	if (locale === "nl") return nl_notifications_tabs_notifications(inputs)
	if (locale === "no") return no_notifications_tabs_notifications(inputs)
	if (locale === "pl") return pl_notifications_tabs_notifications(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_tabs_notifications(inputs)
	if (locale === "pt") return pt_notifications_tabs_notifications(inputs)
	if (locale === "ro") return ro_notifications_tabs_notifications(inputs)
	if (locale === "fi") return fi_notifications_tabs_notifications(inputs)
	if (locale === "sv") return sv_notifications_tabs_notifications(inputs)
	if (locale === "vi") return vi_notifications_tabs_notifications(inputs)
	if (locale === "tr") return tr_notifications_tabs_notifications(inputs)
	if (locale === "cs") return cs_notifications_tabs_notifications(inputs)
	if (locale === "bg") return bg_notifications_tabs_notifications(inputs)
	if (locale === "ru") return ru_notifications_tabs_notifications(inputs)
	if (locale === "uk") return uk_notifications_tabs_notifications(inputs)
	if (locale === "ar") return ar_notifications_tabs_notifications(inputs)
	if (locale === "hi") return hi_notifications_tabs_notifications(inputs)
	if (locale === "th") return th_notifications_tabs_notifications(inputs)
	if (locale === "ja") return ja_notifications_tabs_notifications(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_tabs_notifications(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_tabs_notifications(inputs)
	return ko_notifications_tabs_notifications(inputs)
});
export { notifications_tabs_notifications as "notifications.tabs.notifications" }